import React from "react";
import { useEffect } from "react";

class SortToggle extends React.Component {
  
    render() {
      const hidden_input_id = "sort_order_" + this.props.field;
      function unBindArrows(id){
         var elements =  document.getElementsByClassName("arrow");
          Array.from(elements).forEach((element) => {
              if(element.id !== id){
                  element.style.color = "#808080";
              }
          });
          
      }
      return (
        <span style={{ marginLeft: "10px" }}>
          <input id={hidden_input_id} sort_order="asc" hidden></input>
          <span
            className="indigo-text"
            onClick={(e) => {
              var element = document.getElementById(
                `sort_order_${this.props.field}`
              );
              var sort_order = element.getAttribute("sort_order");
              sort_order = sort_order === "desc" ? "asc" : "desc";
              element.setAttribute("sort_order", sort_order);
              this.props.setSort(`sort_${this.props.field}=${sort_order}`);
              this.props.setCurrentPage(1);
              console.log(sort_order)
              
              if(sort_order === "desc"){
                  unBindArrows(`up-arrow-${this.props.id}`)
                  var arowUp = document.getElementById(`up-arrow-${this.props.id}`)
                  arowUp.style.color = "#0275d8";
                  // arowUp.classList.add('text-primary');
                  // var arowDown = document.getElementById(`down-arrow-${this.props.id}`)
                  // arowDown.style.color = "#f7f7f7";
                  // arowUp.classList.add('text-muted');
              }else if(sort_order === "asc"){
                  unBindArrows(`down-arrow-${this.props.id}`)
                  
                  var arowDown = document.getElementById(`down-arrow-${this.props.id}`)
                  arowDown.style.color = "#0275d8";
              }
            }}
          >
              
            <i className='fas fa-long-arrow-alt-up arrow' aria-hidden="true" id={`up-arrow-${this.props.id}`}></i>
            <i className="fas fa-long-arrow-alt-down arrow" aria-hidden="true" id={`down-arrow-${this.props.id}`}></i>
          </span>
        </span>
      );
    }
  }

  export default SortToggle;